var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcBackLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.3536 5.14645C12.5488 5.34171 12.5488 5.65829 12.3536 5.85355L8.20711 10L12.3536 14.1464C12.5488 14.3417 12.5488 14.6583 12.3536 14.8536C12.1583 15.0488 11.8417 15.0488 11.6464 14.8536L7.14645 10.3536C6.95118 10.1583 6.95118 9.84171 7.14645 9.64645L11.6464 5.14645C11.8417 4.95118 12.1583 4.95118 12.3536 5.14645Z",
    fill: "#0A829D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcBackLeft);
export default __webpack_public_path__ + "static/media/ac-back-left.20358e988d8d3912a8c33d4cb808c80f.svg";
export { ForwardRef as ReactComponent };